import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { LineBasicMaterial } from './LineBasicMaterial.js';
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>
 * }
 */

var LineDashedMaterial = /*#__PURE__*/function (_LineBasicMaterial) {
  _inheritsLoose(LineDashedMaterial, _LineBasicMaterial);

  function LineDashedMaterial(parameters) {
    var _this;

    _this = _LineBasicMaterial.call(this) || this;
    _this.type = 'LineDashedMaterial';
    _this.scale = 1;
    _this.dashSize = 3;
    _this.gapSize = 1;

    _this.setValues(parameters);

    return _this;
  }

  var _proto = LineDashedMaterial.prototype;

  _proto.copy = function copy(source) {
    _LineBasicMaterial.prototype.copy.call(this, source);

    this.scale = source.scale;
    this.dashSize = source.dashSize;
    this.gapSize = source.gapSize;
    return this;
  };

  return LineDashedMaterial;
}(LineBasicMaterial);

LineDashedMaterial.prototype.isLineDashedMaterial = true;
export { LineDashedMaterial };